document.addEventListener('DOMContentLoaded', function () {
  var trigger = document.getElementById('b_image_xVYV9j');
  var target = document.querySelector('[data-forms-id="forms-root-838263"]');

  if (!trigger || !target) return;

  trigger.style.cursor = 'pointer';

  trigger.addEventListener('click', function () {
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  });
});